module.exports = __webpack_public_path__ + "img/t_0034.3ccf26b3.gif";